import ApiService from './ApiService';

class AuthService {

  async login(email, password, otp = null) {
    try {
      const response = await ApiService.request({
        method: 'POST',
        url: '/admin/login',
        data: { email, password, ...(otp && { otp }) },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      throw error;
    }
  }

  logout() {
    localStorage.removeItem('admin');
    localStorage.removeItem('permissions');
    window.location.href = process.env.REACT_APP_BASE_PATH + '/admin/login';
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('admin'));
  }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;
